import {saveBillingAddress} from '../../../reducers/deliveryStep/billingAddress/billingAddress';
import {saveShippingAddress} from '../../../reducers/deliveryStep/shippingAddress/shippingAddress';
import {getBillingAddress} from '../../../selectors/billingAddress/billingAddress';
import {getShippingAddress} from '../../../selectors/shippingAddress/shippingAddress';

import {AddressesType} from './deliveryStepRootSaga';

/**
 * Constant which contains data about address operations and opposite address operations
 */
export const ADDRESSES: AddressesType = {
    billing: {
        oppositeValue: 'shipping',
        selector: getBillingAddress,
        updater: saveBillingAddress,
    },
    shipping: {
        oppositeValue: 'billing',
        selector: getShippingAddress,
        updater: saveShippingAddress,
    },
};
